var exports = {
  "u": "x31de4314--775874--section",
  "k": "x31de4314--775874--container",
};

module.exports = exports;
